import React from "react";
import {Button,} from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import BoltIcon from '@mui/icons-material/Bolt';

export default function DHButtonAktionen({label, working, disabled, onClick, style}) {

    return <Button variant="contained" disabled={disabled || working} onClick={() => onClick()} startIcon={working ? <CircularProgress size={20}/> : <BoltIcon/>}
                   style={{textTransform: "none", letterSpacing:"0.1em", ...style}}>{label !== undefined ? label : "Aktionen"}</Button>
}